import { render, staticRenderFns } from "./HistoricoChecadas.vue?vue&type=template&id=92716dd4&scoped=true"
import script from "./HistoricoChecadas.vue?vue&type=script&lang=js"
export * from "./HistoricoChecadas.vue?vue&type=script&lang=js"
import style0 from "./HistoricoChecadas.vue?vue&type=style&index=0&id=92716dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92716dd4",
  null
  
)

export default component.exports